import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-payment-status',
  imports: [CommonModule, RouterModule],
  templateUrl: './payment-status.html',
  styleUrl: './payment-status.scss'
})
export class PaymentStatus implements OnInit {
  status: 'success' | 'failed' | 'cancelled' | 'pending' = 'pending';
  orderId = '';
  paymentId = '';
  message = '';
  errorMessage = '';
  amount = 0;
  cartItems: any[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    // Get status from query parameters
    this.route.queryParams.subscribe(params => {
      this.status = params['status'] || 'pending';
      this.orderId = params['orderId'] || '';
      this.paymentId = params['paymentId'] || '';
      this.message = params['message'] || '';
      this.errorMessage = params['error'] || '';
      this.amount = parseFloat(params['amount'] || '0');
      
      // Get cart items if available
      if (params['items']) {
        try {
          this.cartItems = JSON.parse(params['items']);
        } catch (e) {
          this.cartItems = [];
        }
      }

      // Set default messages based on status
      this.setStatusMessages();
    });
  }

  private setStatusMessages(): void {
    switch (this.status) {
      case 'success':
        this.message = this.message || 'Your payment was successful and order has been placed!';
        break;
      case 'failed':
        this.message = this.message || 'Payment failed. Your order could not be placed.';
        this.errorMessage = this.errorMessage || 'Please try again or contact support.';
        break;
      case 'cancelled':
        this.message = this.message || 'Payment was cancelled.';
        this.errorMessage = this.errorMessage || 'You can try again when you are ready.';
        break;
      default:
        this.message = this.message || 'Processing your payment...';
    }
  }

  // Translation method
  t(key: string, params?: any): string {
    return this.languageService.t(key, params);
  }

  // Get status icon
  getStatusIcon(): string {
    switch (this.status) {
      case 'success':
        return 'fas fa-check-circle';
      case 'failed':
        return 'fas fa-times-circle';
      case 'cancelled':
        return 'fas fa-ban';
      default:
        return 'fas fa-clock';
    }
  }

  // Get status color
  getStatusColor(): string {
    switch (this.status) {
      case 'success':
        return '#4CAF50';
      case 'failed':
        return '#f44336';
      case 'cancelled':
        return '#ff9800';
      default:
        return '#2196F3';
    }
  }

  // Get status title
  getStatusTitle(): string {
    switch (this.status) {
      case 'success':
        return 'Payment Successful!';
      case 'failed':
        return 'Payment Failed';
      case 'cancelled':
        return 'Payment Cancelled';
      default:
        return 'Processing Payment';
    }
  }

  // Action buttons based on status
  goToHome(): void {
    this.router.navigate(['/home']);
  }

  retryPayment(): void {
    // Navigate back to cart to retry
    this.router.navigate(['/cart']);
  }

  viewOrder(): void {
    if (this.orderId) {
      this.router.navigate(['/orders'], { queryParams: { order: this.orderId } });
    } else {
      this.router.navigate(['/orders']);
    }
  }

  contactSupport(): void {
    this.router.navigate(['/contact']);
  }
}

